if (!customElements.get('anodization-picker')) {
  class AnodizationPicker extends HTMLElement {
    connectedCallback() {
      this.refInput = this.querySelector('[data-anodization-ref-input]');
      this.selectedLabel = this.querySelector('[data-anodization-selected-label]');
      this.toggleBtn = this.querySelector('[data-anodization-toggle]');
      this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));

      this.radios.forEach((radio) => {
        radio.addEventListener('change', () => this._onSelect(radio));
      });

      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => this._toggleCollapse());
      }
    }

    _onSelect(radio) {
      if (this.refInput) {
        this.refInput.value = radio.dataset.colorHandle || '';
        this.refInput.disabled = false;
      }
      if (this.selectedLabel) {
        this.selectedLabel.textContent = radio.dataset.colorLabel || radio.value;
      }
    }

    _toggleCollapse() {
      const expanded = this.toggleBtn.getAttribute('aria-expanded') === 'true';
      const next = !expanded;
      this.toggleBtn.setAttribute('aria-expanded', next ? 'true' : 'false');
      this.querySelectorAll('.anodization-picker__cell--collapsed').forEach((cell) => {
        if (next) {
          cell.removeAttribute('hidden');
        } else {
          cell.setAttribute('hidden', '');
        }
      });
      const moreEl = this.toggleBtn.querySelector('[data-anodization-toggle-more]');
      const lessEl = this.toggleBtn.querySelector('[data-anodization-toggle-less]');
      if (moreEl) moreEl.hidden = next;
      if (lessEl) lessEl.hidden = !next;
    }
  }

  customElements.define('anodization-picker', AnodizationPicker);
}
